import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const PLAY_STORE = 'https://play.google.com/store/apps/details?id=in.mothersgold.mintamilli';
const APP_STORE = 'https://apps.apple.com/in/app/mint-a-milli/id6762197427';
const MINT_A_MILLI_LOGO = 'https://customer-assets-eiarnc6j.emergentagent.net/job_mothers-gold-app/artifacts/tfuyaj5k_512x512-Mothers%20Millis.png';
const MOTHERS_GOLD_LOGO = 'https://customer-assets-eiarnc6j.emergentagent.net/job_mothers-gold-app/artifacts/trnlubgr_mothers-gold-logo.jpg';

const DownloadPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('Checking your device…');
  
  const refCode = searchParams.get('ref') || searchParams.get('code') || null;

  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(ua);
    const isAppleMobile = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
    
    const target = isAndroid 
      ? PLAY_STORE + (refCode ? '&referrer=utm_source%3Dreferral%26utm_content%3D' + encodeURIComponent(refCode) : '')
      : isAppleMobile ? APP_STORE : null;
    
    if (target) {
      setStatus('Opening your app store… If nothing happens, tap the button below.');
      setTimeout(() => {
        window.location.replace(target);
      }, 350);
    } else {
      setStatus('Choose your app store below.');
    }
  }, [refCode]);

  return (
    <div style={{
      margin: 0,
      minHeight: '100vh',
      display: 'grid',
      placeItems: 'center',
      padding: '24px',
      background: 'radial-gradient(circle at 15% 0%, #e9e1c8 0, transparent 42%), linear-gradient(145deg, #fdfbf4, #e9f1e8)',
      color: '#0c3a2c',
      fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif'
    }}>
      <main style={{
        width: 'min(100%, 480px)',
        textAlign: 'center',
        border: '1px solid #dbcaa6',
        background: '#fffefbf0',
        borderRadius: '24px',
        padding: '44px 30px',
        boxShadow: '0 20px 55px #173d3020'
      }}>
        {/* Logos */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '16px',
          marginBottom: '18px'
        }}>
          <img 
            src={MINT_A_MILLI_LOGO} 
            alt="Mint A Milli Logo"
            style={{
              width: '80px',
              height: '80px',
              borderRadius: '20px',
              objectFit: 'contain'
            }}
          />
          <div style={{
            width: '1px',
            height: '50px',
            background: 'linear-gradient(to bottom, transparent, #bf943d, transparent)'
          }}></div>
          <img 
            src={MOTHERS_GOLD_LOGO} 
            alt="Mothers' Gold & Diamonds Logo"
            style={{
              width: '80px',
              height: '80px',
              borderRadius: '12px',
              objectFit: 'contain'
            }}
          />
        </div>

        {/* Eyebrow */}
        <div style={{
          color: '#85631f',
          fontSize: '12px',
          fontWeight: 700,
          letterSpacing: '0.17em',
          textTransform: 'uppercase'
        }}>
          Mothers' Gold & Diamonds
        </div>

        {/* Title */}
        <h1 style={{
          fontFamily: 'Georgia, serif',
          fontSize: 'clamp(32px, 7vw, 44px)',
          margin: '12px 0 6px',
          letterSpacing: '-0.03em',
          color: '#0c3a2c'
        }}>
          Mint A Milli
        </h1>

        {/* Description */}
        <p style={{ color: '#54675c', lineHeight: 1.6 }}>
          Book your Gold in millis with just ₹100. Redeem anytime at our Mothers' Gold & Diamonds showrooms.
        </p>

        {/* Referral Badge */}
        {refCode && (
          <div style={{
            background: '#fff7e6',
            border: '1px solid #d4a84b',
            borderRadius: '12px',
            padding: '12px 16px',
            margin: '16px 0'
          }}>
            <p style={{ color: '#85631f', fontSize: '14px', margin: 0 }}>
              Referral code: <strong style={{ fontSize: '16px', letterSpacing: '0.1em' }}>{refCode}</strong>
            </p>
            <p style={{ color: '#a67c3d', fontSize: '12px', margin: '4px 0 0' }}>
              Get ₹50 worth of gold FREE on your first booking!
            </p>
          </div>
        )}

        {/* Status */}
        <p style={{ fontSize: '14px', minHeight: '22px', color: '#54675c' }}>
          {status}
        </p>

        {/* Buttons */}
        <div style={{ display: 'grid', gap: '12px', marginTop: '24px' }}>
          <a 
            href={PLAY_STORE + (refCode ? '&referrer=utm_source%3Dreferral%26utm_content%3D' + encodeURIComponent(refCode) : '')}
            style={{
              display: 'block',
              borderRadius: '12px',
              textDecoration: 'none',
              padding: '15px 18px',
              background: '#17573f',
              color: 'white',
              fontWeight: 700
            }}
          >
            Get it on Google Play
          </a>
          <a 
            href={APP_STORE}
            style={{
              display: 'block',
              borderRadius: '12px',
              textDecoration: 'none',
              padding: '15px 18px',
              background: 'white',
              color: '#17573f',
              border: '2px solid #17573f',
              fontWeight: 700
            }}
          >
            Download on the App Store
          </a>
        </div>

        {/* Footer */}
        <footer style={{ fontSize: '12px', marginTop: '30px', color: '#6b7a70' }}>
          Having trouble? Select your store above.<br />
          <a href="/home-new" style={{ color: '#17573f' }}>Visit Mint A Milli website</a>
        </footer>
      </main>
    </div>
  );
};

export default DownloadPage;
